// Split a Hanyu Pinyin string into individual syllables, regardless of how the
// author spaced them. Handles tone marks and the trailing 'er' / 'r' suffix.
//
//   "shénme"            -> ["shén", "me"]
//   "Nǐ zài zuò shénme?"-> ["Nǐ", "zài", "zuò", "shén", "me"]
//   "Zhōngguó"          -> ["Zhōng", "guó"]
//
// We greedily match: optional initial (zh/ch/sh or single consonant) + a
// vowel cluster (with tone marks) + optional final n/ng/r.
const SYLLABLE_RE =
  /(?:zh|ch|sh|[bpmfdtnlgkhjqxrzcsyw])?(?:[aeiouüv\u00E0-\u00FC\u0101\u00E1\u01CE\u00E0\u0113\u00E9\u011B\u00E8\u012B\u00ED\u01D0\u00EC\u014D\u00F3\u01D2\u00F2\u016B\u00FA\u01D4\u00F9\u01D6\u01D8\u01DA\u01DC]+)(?:ng|n|r)?/gi;

export function splitPinyinSyllables(pinyin) {
  if (!pinyin) return [];
  // Strip punctuation so it doesn't confuse the matcher.
  const clean = pinyin.replace(/[，。！？、；：""''()（）?!.,]/g, ' ');
  const out = [];
  for (const word of clean.split(/\s+/).filter(Boolean)) {
    const matches = word.match(SYLLABLE_RE);
    if (matches && matches.length) out.push(...matches);
    else out.push(word);
  }
  return out;
}
